import React from 'react'

const π = Math.PI

const TRACK_STROKE_W = 2
const PROG_STROKE_W = 3

// exclamation path is a bit wacked on export,
// need to correct origin (eyeballed on zoom)
const EXC_OX = -1.4
const EXC_OY = 13
const EXC_W = 3.7  // browser measures 3.17; on my chrome it looks more accurate at 3.7
const EXC_H = 13.24

const TimerProgressIndicator = React.memo(props => {
  const R = props.R || 13.5
  const W = (R + PROG_STROKE_W) * 2
  const H = W
  const CX = W / 2
  const CY = H / 2
  const PROG_START_X = CX  // start the progress ARC @ 12:00
  const PROG_START_Y = CY - R
  const EXC_X = EXC_OX + CX - (EXC_W / 2)
  const EXC_Y = EXC_OY + CY - (EXC_H / 2)
  
  const progress = Math.max(props.progress || 0, 0)

  let partialPath = null
  if(progress < 1) {
    const prog_end_θ = (-0.5 * π) - (progress * (2 * π))
    const prog_end_X = (Math.cos(prog_end_θ) * R) + CX
    const prog_end_Y = (Math.sin(prog_end_θ) * R) + CY
    const is_large_arc = (progress <= .5) ? 0 : 1
    const prog_path_D = `M ${PROG_START_X} ${PROG_START_Y} A ${R} ${R} 0 ${is_large_arc} 0 ${prog_end_X} ${prog_end_Y}`
    partialPath = (
      <path className="timer-timer-progress" d={prog_path_D} strokeWidth={PROG_STROKE_W} />
    )
  }

  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`}>
      <circle className="timer-timer-track" cx={CX} cy={CY} r={R} strokeWidth={TRACK_STROKE_W} />
      {partialPath ? partialPath : (
        <>
          <circle className="timer-timer-progress" cx={CX} cy={CY} r={R} strokeWidth={PROG_STROKE_W} />
          <path className="timer-timer-exclamation"
            d="M4.716-13.113v5.148a13.6,13.6,0,0,1-.1,1.643q-.1.814-.261,1.66H2.466Q2.3-5.508,2.2-6.322a13.6,13.6,0,0,1-.1-1.643v-5.148ZM1.8-1.413a1.494,1.494,0,0,1,.121-.6A1.524,1.524,0,0,1,2.254-2.5a1.589,1.589,0,0,1,.5-.329,1.6,1.6,0,0,1,.63-.122,1.581,1.581,0,0,1,.621.122,1.645,1.645,0,0,1,.5.329,1.49,1.49,0,0,1,.338.486,1.494,1.494,0,0,1,.122.6,1.526,1.526,0,0,1-.122.608,1.477,1.477,0,0,1-.338.491,1.58,1.58,0,0,1-.5.324,1.634,1.634,0,0,1-.621.117,1.658,1.658,0,0,1-.63-.117,1.527,1.527,0,0,1-.5-.324,1.511,1.511,0,0,1-.333-.491A1.526,1.526,0,0,1,1.8-1.413Z"
            transform={`translate(${EXC_X} ${EXC_Y})`}
          />
        </>
      )}
    </svg>
  )
})

export default TimerProgressIndicator
